const config = {
  isMockEnabled: false,
  responseDelay: 500,
  isDemo: true,
  token: 'simple-construction-token',
}

export default config
